import './index.scss';

const MODAL_SELECTOR = '#js-not-elite-user-modal';
const CTA_SELECTOR = '#js-not-elite-user-modal-cta';
const FEATURE_NAME = 'Exercícios de Fixação';

function emit(eventName) {
  window.UserTracker.emit('event', {
    eventName: eventName,
    data: {
      'feature name': FEATURE_NAME,
      'source platform': 'portal',
      'source project': 'odin'
    }
  });
}

(function ($) {
  'use strict';

  $(document).on('shown.bs.modal', MODAL_SELECTOR, () => {
    emit('upgrade modal viewed');
  });

  // Cobre "Agora não", o ESC e o clique fora numa única regra. O CTA é um <a>
  // com navegação nativa, então não dispara `hidden.bs.modal` — não há risco de
  // contar um dismiss junto com o clique no CTA.
  $(document).on('hidden.bs.modal', MODAL_SELECTOR, () => {
    emit('upgrade modal dismissed');
  });

  $(document).on('click', CTA_SELECTOR, () => {
    emit('upgrade modal cta clicked');
  });
})(jQuery);
